<template>
   <article class="portada-nosotros">
      <div class="overlay"></div>
      <section class="contenido">
         <h2>NOSOTROS</h2>
         <p>
            Somos un proveedor de precios aprobado y regulado por las principales comisiones
            en los mercados donde operamos. Desde nuestros inicios hemos sido líderes en el
            servicio de cálculo, determinación y proveeduría o suministro de precios actualizados
            para valuación de valores, documentos e instrumentos financieros.
         </p>
         <input class="ver-mas" type="button" value="Ver más" v-on:click="showVideo()">
      </section>
   </article>
   <div class="pantalla" v-if="dispVideo" @click="closeVideo">
      <div class="video-container">
         <video autoplay controls width="1080" height="630">
            <source :src="urlStatics + '/vid/PiP_Video_V03_2.mp4'" type="video/mp4">
            Tu navegador no soporta el elemento de video.
         </video>
      </div>
   </div>
</template>

<script>
export default {
   name: "PortadaNosotros",
   inject: ["urlStatics"],
   data() {
      return {
         dispVideo: false
      };
   },

   methods: {
      showVideo() {
         this.dispVideo = true;
      },

      closeVideo() {
         this.dispVideo = false;
      }
   }
}
</script>

<style scoped>
.portada-nosotros {
   width: 100%;
   min-height: 55vh;
   background-image: url('https://new.piplatam.com/img/portada.jpg');
   background-size: cover;
   background-position: center;
   background-attachment: fixed;
   display: flex;
   align-items: center;
}

.overlay {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   min-height: 55vh;
   background-color: rgba(0, 0, 0, 0.6);
   /* oscurece la imagen */
   z-index: 1;
}

.contenido {
   max-width: 25%;
   color: white;
   margin-left: 5%;
   padding: 2rem;
   border-radius: 8px;
   z-index: 2;
}

h2 {
   font-size: 2rem;
   margin-bottom: 1rem;
}

p {
   font-size: 1rem;
   line-height: 1.6;
}

.ver-mas {
   height: 40px;
   width: 100px;
   margin-top: 1em;
   display: inline-block;
   padding: 0.5rem 1rem;
   border-radius: 8px;
   border: 2px solid rgba(255, 255, 255, 0.6);
   backdrop-filter: blur(10px);
   background-color: rgba(255, 255, 255, 0.1);
   color: white;
   font-size: 16px;
   font-weight: 500;
   font-family: 'Montserrat', sans-serif;
   transition: all 0.3s ease;
   text-decoration: none;
}

.ver-mas:hover {
   background-color: rgba(255, 255, 255, 0.2);
   border-color: white;
   color: #fff;
   cursor: pointer;
}

.pantalla {
   position: fixed;
   top: 0;
   left: 0;
   width: 100vw;
   height: 100vh;
   z-index: 100;
   display: flex;
   justify-content: center;
   align-items: center;
}

.video-container {
   max-width: 1080px;
   max-height: 720px;
   margin: 0 auto;
   padding: 1rem;
   background-color: black;
   border-radius: 8px;
   box-shadow: 0px 10px 40px rgba(100, 100, 100, 0.4);
}

/* Responsivo */
@media (max-width: 768px) {
   .contenido {
      max-width: 90%;
      margin: 0 auto;
      padding: 1.5rem;
   }

   h2 {
      font-size: 1.6rem;
   }

   p {
      font-size: 0.95rem;
   }
}

@media (max-width: 480px) {
   .portada-nosotros {
      min-height: 60vh;
      padding: 3rem 0;
   }

   .overlay {
      min-height: 75vh;
   }

   .contenido {
      padding: 1rem;
   }

   h2 {
      font-size: 1.4rem;
   }

   p {
      font-size: 0.9rem;
   }
}

@supports (-webkit-touch-callout: none) {
   .portada-nosotros {
      background-attachment: scroll;
   }
}
</style>
